// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .fields-wrapper .field-list ion-list:not(.edit) ion-item.has-sub-label.has-sub-value ion-note {
  font-size: 12px;
  color: var(--ion-color-medium-tint);
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 40%;
  white-space: nowrap;
}
:host ::ng-deep ion-item {
  padding-top: 0px;
}
:host ::ng-deep .item-inner {
  padding-right: 0;
  margin-right: 5px;
}

ion-fab {
  margin-bottom: 50px;
}

.mc-items {
  padding-top: 0;
  margin-bottom: 90px;
}

.mc-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0px;
}

.mc-item-left {
  flex: 1;
  display: flex;
  align-items: center;
}

.mc-item-left-thumbnail {
  margin-right: 10px;
}

.mc-item-text {
  display: flex;
  flex-direction: column;
}

.mc-item-text ion-note {
  font-size: 16px;
  font-weight: bold;
}

.mc-item-text ion-note:not(:first-child) {
  font-size: 14px;
  font-weight: normal;
}

.mc-item-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-wrap: wrap;
  align-content: flex-end;
}

.mc-item-right ion-note {
  flex-wrap: wrap;
  text-align: end;
}

.mc-item-right ion-note:last-child {
  margin-bottom: 0;
}

.custom-note {
  display: block;
  font-size: 14px;
}

.bottom-note {
  padding-bottom: 5px;
}

.mc-item-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.mc-item-text {
  flex-grow: 1;
}

.icon-right {
  margin-left: 10px;
}

@media (max-width: 640px) {
  .hide-right {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/text-library/text-library.component.scss"],"names":[],"mappings":"AACC;EACC,eAAA;EACA,mCAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AAAF;AAGI;EACI,gBAAA;AADR;AAIC;EACC,gBAAA;EACA,iBAAA;AAFF;;AAMA;EACC,mBAAA;AAHD;;AAMA;EACC,cAAA;EACA,mBAAA;AAHD;;AAMA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAHD;;AAMA;EACC,OAAA;EACA,aAAA;EACA,mBAAA;AAHD;;AAMA;EACC,kBAAA;AAHD;;AAMA;EACC,aAAA;EACA,sBAAA;AAHD;;AAMA;EACC,eAAA;EACA,iBAAA;AAHD;;AAMA;EACC,eAAA;EACA,mBAAA;AAHD;;AAMA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AAHD;;AAMA;EACC,eAAA;EACA,eAAA;AAHD;;AAMA;EACC,gBAAA;AAHD;;AAMA;EACC,cAAA;EACA,eAAA;AAHD;;AAMA;EACC,mBAAA;AAHD;;AAMA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAHD;;AAMA;EACC,YAAA;AAHD;;AAMA;EACC,iBAAA;AAHD;;AAOA;EACC;IACC,aAAA;EAJA;AACF","sourcesContent":[":host ::ng-deep {\r\n\t.fields-wrapper .field-list ion-list:not(.edit) ion-item.has-sub-label.has-sub-value ion-note {\r\n\t\tfont-size: 12px;\r\n\t\tcolor: var(--ion-color-medium-tint);\r\n\t\toverflow: hidden;\r\n\t\ttext-overflow: ellipsis;\r\n\t\tmax-width: 40%;\r\n\t\twhite-space: nowrap;\r\n\t}\r\n\r\n    ion-item {\r\n        padding-top: 0px;\r\n    }\r\n\r\n\t.item-inner {\r\n\t\tpadding-right: 0;\r\n\t\tmargin-right: 5px;\r\n\t}\r\n}\r\n\r\nion-fab {\r\n\tmargin-bottom: 50px;\r\n}\r\n\r\n.mc-items {\r\n\tpadding-top: 0;\r\n\tmargin-bottom: 90px;\r\n}\r\n\r\n.mc-item {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding-top: 0px;\r\n}\r\n\r\n.mc-item-left {\r\n\tflex: 1;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.mc-item-left-thumbnail {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.mc-item-text {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.mc-item-text ion-note {\r\n\tfont-size: 16px;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.mc-item-text ion-note:not(:first-child) {\r\n\tfont-size: 14px;\r\n\tfont-weight: normal;\r\n}\r\n\r\n.mc-item-right {\r\n\tflex: 1;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: flex-end;\r\n\tflex-wrap: wrap;\r\n\talign-content: flex-end;\r\n}\r\n\r\n.mc-item-right ion-note {\r\n\tflex-wrap: wrap;\r\n\ttext-align: end;\r\n}\r\n\r\n.mc-item-right ion-note:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.custom-note {\r\n\tdisplay: block;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.bottom-note {\r\n\tpadding-bottom: 5px;\r\n}\r\n\r\n.mc-item-right {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\twidth: 100%;\r\n}\r\n\r\n.mc-item-text {\r\n\tflex-grow: 1;\r\n}\r\n\r\n.icon-right {\r\n\tmargin-left: 10px;\r\n}\r\n\r\n\r\n@media (max-width: 640px) {\r\n\t.hide-right {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
